import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E033BCF1-3B41-4885-9700-CE4B85A7106C
 * name wall-sconce-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce-outline.svg
 * tags
 * - Home Automation 
 */
export const WallSconceOutlineIcon = createSvgIcon(<><path d="M13.7 6L15.92 11H10.08L12.3 6H13.7M15 4H11L7 13H19L15 4M4 14V22H6V19H14V14H12V17H6V14H4Z" /></>, 'WallSconceOutlineIcon');
export default WallSconceOutlineIcon